/* Layouts Types */
import LayoutPage from '@/components/layout/LayoutPage.vue';

/* Style SCSS */
//import './scss/wits-admin-ui.css';
//import './scss/_variables.scss';
import '@/scss/wits-admin-ui.scss';

/* Icons */
import 'material-icons/iconfont/material-icons.scss';
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

/* Configurations */
import './config/bootstrap.js'
import './config/mermaid.js'
import './config/mq.js'

import router from './config/router.js'
import store from './config/stores/store.js'
import moment from 'moment'

import Vue from 'vue'
import App from './App.vue'

Vue.component('layout-page', LayoutPage);
Vue.prototype.moment = moment
Vue.config.productionTip = false

new Vue({
  router,
  store,
  moment,
  render: h => h(App),
}).$mount('#app')
